"use strict";

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.weak-map");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.BankingProductCtaPropTypes = exports.TRK_CODE = exports.OUTBOUND_CTA_TEXT = exports.REVIEW_CTA_TEXT = exports.LINK_TYPES = exports.DISPLAY_PAGES = void 0;

require("core-js/modules/es7.object.values");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.object.define-properties");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.reflect.construct");

require("core-js/modules/es6.object.set-prototype-of");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.string.link");

var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));

var _isString2 = _interopRequireDefault(require("lodash/isString"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _deprecate = require("@nerdwallet/deprecate");

var _impression = require("@nerdwallet/analytics/react/impression");

var _reactApplyNow = _interopRequireWildcard(require("@nerdwallet/react-apply-now"));

var _Launch = _interopRequireDefault(require("@nerdwallet/react-icon/material/Launch"));

var _reactImage = _interopRequireDefault(require("@nerdwallet/react-image"));

var _currency = require("@nerdwallet/currency");

var _variables = require("@nerdwallet/base-styles/variables");

var _banking = require("@nerdwallet/marketplace/selectors/banking");

var _common = require("@nerdwallet/marketplace/selectors/common");

var _composed = _interopRequireDefault(require("./composed"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/*
  Offer details display_pages field values
*/
var DISPLAY_PAGES = {
  CONTENT: 'CONTENT',
  COMPARISON: 'COMPARISON',
  DIGITAL_MARKETING: 'DIGITAL_MARKETING',
  IPX_CARDS: 'IPX_CARDS',
  MARKETPLACE: 'MARKETPLACE',
  PERSONALIZED_REC_FLOWS: 'PERSONALIZED_REC_FLOWS',
  REVIEWS: 'REVIEWS',
  ROUNDUPS: 'ROUNDUPS',
  TOOLS: 'TOOLS'
};
exports.DISPLAY_PAGES = DISPLAY_PAGES;
var LINK_TYPES = {
  BUTTON: 'BUTTON',
  LINK: 'LINK'
};
exports.LINK_TYPES = LINK_TYPES;
var REVIEW_CTA_TEXT = 'Read Review';
exports.REVIEW_CTA_TEXT = REVIEW_CTA_TEXT;
var OUTBOUND_CTA_TEXT = 'Learn More';
exports.OUTBOUND_CTA_TEXT = OUTBOUND_CTA_TEXT;
var TRK_CODE = 'read_review_cta_click';
exports.TRK_CODE = TRK_CODE;

var BankingProductCta = /*#__PURE__*/function (_React$Component) {
  _inherits(BankingProductCta, _React$Component);

  var _super = _createSuper(BankingProductCta);

  function BankingProductCta() {
    _classCallCheck(this, BankingProductCta);

    return _super.apply(this, arguments);
  }

  _createClass(BankingProductCta, [{
    key: "getLinkType",

    /**
     * Get the correct linkType.
     *
     * This logic intentionally only supports applyNowButton and
     * applyLink linkType's because we will ideally deprecate all other
     * values in the near future and instead add a new prop to support
     * link content type for things like "product image".
     *
     * @see https://nerdwallet.slack.com/archives/GEGNG6UDQ/p1545155066006000
     *
     * @return {string} Link type value.
     */
    value: function getLinkType() {
      var _this$props = this.props,
          linkType = _this$props.linkType,
          type = _this$props.type;

      if (linkType) {
        return linkType;
      }

      return type === LINK_TYPES.BUTTON ? _reactApplyNow.LinkType.applyNowButton : _reactApplyNow.LinkType.applyLink;
    }
  }, {
    key: "getApplyNowProps",
    value: function getApplyNowProps(childrenOverride) {
      var _this$props2 = this.props,
          children = _this$props2.children,
          classNameApplyNow = _this$props2.classNameApplyNow,
          id = _this$props2.id,
          offer = _this$props2.offer,
          pageNumber = _this$props2.pageNumber,
          pageType = _this$props2.pageType,
          productDisplayDriver = _this$props2.productDisplayDriver,
          productPosition = _this$props2.productPosition,
          sectionName = _this$props2.sectionName,
          sectionPosition = _this$props2.sectionPosition,
          shortButton = _this$props2.shortButton,
          icon = _this$props2.icon,
          showIcon = _this$props2.showIcon,
          shouldLogImpression = _this$props2.shouldLogImpression;
      var issuerName = (0, _banking.getIssuerName)(offer);
      var productName = (0, _banking.getProductName)(offer);
      return {
        children: childrenOverride || children,
        className: classNameApplyNow,
        disableAnnotation: true,
        id: id,
        isCC: false,
        issuer: issuerName,
        linkType: this.getLinkType(),
        logImpression: shouldLogImpression,
        pageNumber: pageNumber,
        productDisplayDriver: productDisplayDriver,
        productId: offer.id,
        productLocation: "banking-page_type-".concat(pageType),
        productPosition: productPosition,
        productSlug: "".concat(issuerName, "-").concat(productName),
        sectionName: sectionName,
        sectionPosition: sectionPosition,
        shortButton: shortButton,
        showIcon: showIcon,
        icon: icon,
        vertical: 'Banking Rate'
      };
    }
  }, {
    key: "getLinkAndTextProps",
    value: function getLinkAndTextProps() {
      var _this$props3 = this.props,
          pageType = _this$props3.pageType,
          offer = _this$props3.offer,
          link = _this$props3.link;
      var showOutboundCta = (0, _banking.getIsMonetizing)(offer);
      var reviewUrl = (0, _common.getLearnMoreLink)(offer) || ''; // Replace the apply link with link override if it is valid

      var applyLink = (0, _isString2["default"])(link) && link ? link : (0, _common.getApplyLink)(offer);
      var offerUrl = (0, _banking.getOfferUrl)(offer);

      if (showOutboundCta || !reviewUrl) {
        return {
          finishType: _reactApplyNow.FinishType.EXTERNAL_APPLICATION,
          link: applyLink,
          monetizable: _reactApplyNow.Monetizable.yesAssumed,
          text: OUTBOUND_CTA_TEXT
        };
      }

      if (pageType === DISPLAY_PAGES.REVIEWS) {
        // Reviews (banking profile pages) always output our partner link, so we need to
        // determine whether or not it is actually monetizable.
        var monetizable = showOutboundCta ? _reactApplyNow.Monetizable.yesAssumed : _reactApplyNow.Monetizable.noBecauseOfLimit;
        return {
          finishType: _reactApplyNow.FinishType.EXTERNAL_APPLICATION,
          link: offerUrl,
          monetizable: monetizable,
          text: OUTBOUND_CTA_TEXT
        };
      }

      var glue = reviewUrl.indexOf('?') === -1 ? '?' : '&';
      return {
        finishType: _reactApplyNow.FinishType.INTERNAL_CONTENT,
        link: "".concat(reviewUrl).concat(glue, "trk_src=").concat(TRK_CODE),
        monetizable: _reactApplyNow.Monetizable.noBecauseOfLimit,
        text: REVIEW_CTA_TEXT
      };
    }
  }, {
    key: "getAnnotationText",
    value: function getAnnotationText() {
      var _this$props4 = this.props,
          offer = _this$props4.offer,
          hideInstitutionFromAnnotation = _this$props4.hideInstitutionFromAnnotation;
      var federallyInsuredAnnotation = (0, _banking.getFederallyInsuredAnnotation)(offer);
      var displayName = (0, _banking.getIssuerName)(offer);

      if (hideInstitutionFromAnnotation === true) {
        return federallyInsuredAnnotation || '';
      }

      if (federallyInsuredAnnotation) {
        return "at ".concat(displayName, ", ").concat(federallyInsuredAnnotation);
      }

      return "at ".concat(displayName);
    }
  }, {
    key: "renderCtaAnnotation",
    value: function renderCtaAnnotation(ctaText) {
      if (ctaText === REVIEW_CTA_TEXT) {
        return null;
      }

      return /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          textAlign: 'center'
        }
      }, /*#__PURE__*/_react["default"].createElement(_currency.Type, {
        gotham: true,
        light: true,
        size: 1
      }, this.getAnnotationText()));
    }
  }, {
    key: "renderBankingImage",
    value: function renderBankingImage() {
      var _this$props5 = this.props,
          offer = _this$props5.offer,
          showBankLogo = _this$props5.showBankLogo;
      var bankingLogoUrl = (0, _common.getImageSrc)(offer);

      if (!showBankLogo || !bankingLogoUrl) {
        return null;
      }

      var alt = (0, _banking.getIssuerName)(offer); // TODO: getImageAltText

      return /*#__PURE__*/_react["default"].createElement(_reactImage["default"], {
        alt: alt,
        src: bankingLogoUrl,
        className: _composed["default"]['image-container'],
        imageClassName: _composed["default"]['bank-logo'],
        backgroundColor: _variables.colors.white
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props6 = this.props,
          children = _this$props6.children,
          disableBankCtaAnnotation = _this$props6.disableBankCtaAnnotation,
          type = _this$props6.type,
          offer = _this$props6.offer,
          pageType = _this$props6.pageType;
      var displayPages = (0, _banking.getDisplayPages)(offer);
      var isProductDisplayedOnPage = displayPages.indexOf(pageType) > -1;

      if (!isProductDisplayedOnPage) {
        return null;
      }

      var Component = type === LINK_TYPES.LINK ? _reactApplyNow.ApplyNowLink : _reactApplyNow["default"];
      var linkAndTextProps = this.getLinkAndTextProps();
      var childrenOverride = null; // APPLY_NOW_LINK displays children nodes, not 'text'
      // Want to make sure we don't override existing children, e.g. <img>

      if (type === LINK_TYPES.LINK && (0, _isEmpty2["default"])(children)) {
        childrenOverride = [linkAndTextProps.text];
      }

      var applyNowProps = _objectSpread(_objectSpread({}, linkAndTextProps), this.getApplyNowProps(childrenOverride));

      if (applyNowProps.monetizable === _reactApplyNow.Monetizable.yesAssumed || pageType === DISPLAY_PAGES.REVIEWS) {
        applyNowProps = _objectSpread(_objectSpread({}, applyNowProps), {}, {
          showIcon: true,
          icon: /*#__PURE__*/_react["default"].createElement(_Launch["default"], {
            textAligned: true,
            size: 16,
            className: _composed["default"]['launch-icon']
          })
        });
      }

      return /*#__PURE__*/_react["default"].createElement(_impression.ImpressionContext.Consumer, null, function (impressionData) {
        applyNowProps.impressionId = impressionData === null || impressionData === void 0 ? void 0 : impressionData.impressionId;
        return /*#__PURE__*/_react["default"].createElement("div", null, _this.renderBankingImage(), /*#__PURE__*/_react["default"].createElement(Component, applyNowProps), !disableBankCtaAnnotation && _this.renderCtaAnnotation(linkAndTextProps.text));
      });
    }
  }]);

  return BankingProductCta;
}(_react["default"].Component);
/* eslint-disable react/require-default-props */


var BankingProductCtaPropTypes = {
  children: _propTypes["default"].node,
  classNameApplyNow: _propTypes["default"].string,
  disableBankCtaAnnotation: _propTypes["default"].bool,
  finishType: _propTypes["default"].oneOf(Object.values(_reactApplyNow.FinishType)),
  hideInstitutionFromAnnotation: _propTypes["default"].bool,

  /** Unique id for the impression on this page */
  id: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /** Consume link override if provided. */
  link: _propTypes["default"].string,

  /** UX control type that triggered the click. @see ApplyNow/link-types.js for more details. */
  linkType: _propTypes["default"].oneOf([_reactApplyNow.LinkType.applyLink, _reactApplyNow.LinkType.applyNowButton, _reactApplyNow.LinkType.institutionImage, _reactApplyNow.LinkType.offerName, _reactApplyNow.LinkType.productImage, _reactApplyNow.LinkType.productName]),
  monetizable: _propTypes["default"].oneOf([_reactApplyNow.Monetizable.no, _reactApplyNow.Monetizable.yesAssumed, _reactApplyNow.Monetizable.noBecauseOfLimit]),

  /** Shape from the Marketplace API */
  offer: _propTypes["default"].shape({
    id: _propTypes["default"].string,
    details: _propTypes["default"].shape({
      show_outbound_cta: _propTypes["default"].bool,
      display_pages: _propTypes["default"].shape({
        // eslint-disable-next-line react/forbid-prop-types -- directive added automatically by Shepherd migration
        value: _propTypes["default"].array
      }),
      offer_url: _propTypes["default"].shape({
        value: _propTypes["default"].string
      })
    }),
    derived_details: _propTypes["default"].shape({
      apply_link: _propTypes["default"].shape({
        value: _propTypes["default"].string
      })
    }),
    product: _propTypes["default"].shape({
      details: _propTypes["default"].shape({
        display_name: _propTypes["default"].shape({
          value: _propTypes["default"].string
        })
      }),
      institution: _propTypes["default"].shape({
        details: _propTypes["default"].shape({
          federally_insured: _propTypes["default"].shape({
            value: _propTypes["default"].string
          }),
          logo_url: _propTypes["default"].shape({
            value: _propTypes["default"].string
          }),
          display_name: _propTypes["default"].shape({
            value: _propTypes["default"].string
          }),
          nw_review_url: _propTypes["default"].shape({
            value: _propTypes["default"].string
          })
        })
      })
    })
  }),
  pageNumber: _propTypes["default"].number,
  pageType: _propTypes["default"].string,
  productDisplayDriver: _propTypes["default"].string,
  productPosition: _propTypes["default"].number,
  sectionName: _propTypes["default"].string,
  sectionPosition: _propTypes["default"].number,
  shouldLogImpression: _propTypes["default"].bool,
  shortButton: _propTypes["default"].bool,
  showBankLogo: _propTypes["default"].bool,
  icon: _propTypes["default"].node,
  showIcon: _propTypes["default"].bool,

  /** Whether or not to output a button or a link. */
  type: _propTypes["default"].oneOf([LINK_TYPES.BUTTON, LINK_TYPES.LINK])
};
/* eslint-enable react/require-default-props */
// eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration

exports.BankingProductCtaPropTypes = BankingProductCtaPropTypes;
BankingProductCta.propTypes = BankingProductCtaPropTypes; // eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration

BankingProductCta.defaultProps = {
  disableBankCtaAnnotation: false,
  hideInstitutionFromAnnotation: false,
  shouldLogImpression: true,
  showBankLogo: false,
  shortButton: false,
  icon: null,
  showIcon: false,
  type: LINK_TYPES.BUTTON
};

var _default = (0, _deprecate.withDeprecatedComponentWarning)({
  version: '4.6.1',
  migration: 'Use the <MarketplaceApplyNow> component from @nerdwallet/react-marketplace-apply-now instead.'
})(BankingProductCta);

exports["default"] = _default;